import { FC } from 'react'
import { RouteObject } from 'react-router-dom'
import Legal from '../__legacy__/components/legal/Legal'
import { Segment } from '../features/segment'


const LegalPage: FC = () => (
  <Segment.ViewTracker attributes={{ path: '/legal'}}>
    <Legal />
  </Segment.ViewTracker>
)

export const LegalRoute: RouteObject = {
  path: '/legal/*',
  element: <LegalPage />
}
